// Bundle switch — resolved at build time via REACT_APP_BUNDLE env var.
// webpack replaces process.env.REACT_APP_BUNDLE with a string literal so the
// dead branch is tree-shaken in production: the guardian build never includes
// support code and vice versa.
const bundle = process.env.REACT_APP_BUNDLE || 'guardian';
if (bundle === 'support') {
  // eslint-disable-next-line global-require
  require('./support/index');
} else {
  // eslint-disable-next-line global-require
  require('./guardian/index');
}
